import React from "react";
import { Icon } from "../icons";
import { socialMedia } from "../../config/constants";

import { StyledFooter, StyledSocialLinks, StyledCredit } from "./Footer.styles";

const Footer = () => {
  return (
    <StyledFooter>
      <StyledSocialLinks>
        <ul>
          {socialMedia &&
            socialMedia.map(({ name, url }) => (
              <li key={name}>
                <a
                  href={url}
                  aria-label={name}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Icon name={name} />
                </a>
              </li>
            ))}
        </ul>
      </StyledSocialLinks>

      <StyledCredit tabIndex="-1">
        <small>&copy; 2026 Maria An. All Rights Reserved.</small>
      </StyledCredit>
    </StyledFooter>
  );
};

export default Footer;
